/* Mellomy 2026-10-09 store batch. Loaded (defer) from layout/theme.liquid. */
(function () {
  "use strict";
  var mmS = window.mmS || function (k, d) { return d; }, mmF = window.mmF || function (k, d, o) { return String(d).replace(/\{(\w+)\}/g, function (x, n) { return o && o[n] != null ? o[n] : x; }); }, mmP = window.mmP || function (p) { return p; }, mmL = window.mmL || function (t) { return t; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var VOL = 0.25;
  function readJSON(id) { var n = document.getElementById(id); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  function arrowLink(cls, href, label) {
    var a = document.createElement("a");
    a.className = cls; a.href = href;
    a.innerHTML = label + ' <span aria-hidden="true">&rarr;</span>';
    return a;
  }
  // R15: sharp images on Shopify CDN (srcset by width)
  function cdnW(u, w) {
    if (!u || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
    var x = u.replace(/([?&])width=\d+(&|$)/, "$1").replace(/[?&]$/, "");
    return x + (x.indexOf("?") < 0 ? "?" : "&") + "width=" + w;
  }
  function sharpImg(img, u, sizes) {
    img.src = cdnW(u, 600);
    if (u && /\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) {
      img.srcset = [300, 450, 600, 800].map(function (w) { return cdnW(u, w) + " " + w + "w"; }).join(", ");
      img.sizes = sizes;
    }
  }
  var HEADSET = '<path d="M4 13v-1a8 8 0 0 1 16 0v1" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="3" y="13" width="4" height="6" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/><rect x="17" y="13" width="4" height="6" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/>';
  // R15: open Shopify Inbox chat if present; returns true on success
  function openInboxChat() {
    try {
      if (window.ShopifyChat && typeof window.ShopifyChat.open === "function") { window.ShopifyChat.open(); return true; }
      var el = document.querySelector("shopify-chat, inbox-online-store-chat");
      if (!el) return false;
      if (typeof el.open === "function") { el.open(); return true; }
      var sr = el.shadowRoot;
      var b = sr && (sr.querySelector('[part~="activator"]') || sr.querySelector("button"));
      if (b) { b.click(); return true; }
    } catch (e) {}
    return false;
  }
  function enhanceSupport(dlg) {
    if (!dlg || dlg.querySelector(".mm-support-chat")) return;
    var box = document.createElement("div"); box.className = "mm-support-chat";
    var p = document.createElement("p");
    p.textContent = mmS("chat_hint", "Or tap the chat button at the bottom left — we usually reply quickly.");
    var b = document.createElement("button"); b.type = "button"; b.className = "mm-support-chat__btn"; b.textContent = mmS("chat_with_us", "Chat with us");
    b.addEventListener("click", function () {
      if (dlg.close) dlg.close();
      if (!openInboxChat()) { if (dlg.showModal) dlg.showModal(); b.hidden = true; }
    });
    if (!document.querySelector("shopify-chat, inbox-online-store-chat") && !window.ShopifyChat) b.hidden = true;
    box.appendChild(p); box.appendChild(b);
    var firstP = dlg.querySelector("p");
    if (firstP && firstP.parentNode) firstP.parentNode.insertBefore(box, firstP.nextSibling); else dlg.appendChild(box);
  }
  function card(item) {
    var a = document.createElement("a");
    a.className = "pdp-card-product"; a.href = item.url;
    var span = document.createElement("span");
    if (item.image) { var img = document.createElement("img"); sharpImg(img, item.image, "(min-width: 990px) 22vw, 45vw"); img.alt = item.title + (item.color ? " \u2013 " + item.color : ""); img.loading = "lazy"; span.appendChild(img); }
    var p = document.createElement("p"); p.textContent = item.title;
    if (item.color) { var c = document.createElement("small"); c.className = "pdp-card-color"; c.textContent = item.color; p.appendChild(c); }
    var strong = document.createElement("strong"); strong.textContent = item.price || "";
    if (item.compare) { var s = document.createElement("s"); s.textContent = item.compare; s.style.cssText = "margin-left:6px;color:#8a8078;font-weight:400;font-size:12px"; strong.appendChild(document.createTextNode(" ")); strong.appendChild(s); }
    a.appendChild(span); a.appendChild(p); a.appendChild(strong);
    return a;
  }

  /* ---------- Header: currency selector (23) + support block in the mobile menu (22) ---------- */
  var extras = $(".mm-header-extras");
  if (extras) {
    var actions = $(".site-header .header-actions");
    var cur = $(".header-currency", extras);
    if (actions && cur) actions.insertBefore(cur, actions.firstChild);
    // R15 (5): desktop customer-support icon, immediately left of the currency selector
    var gdlg = $("[data-mm-support-dialog]", extras);
    if (gdlg) {
      document.body.appendChild(gdlg);
      $$("[data-mm-support-close]", gdlg).forEach(function (x) { x.addEventListener("click", function () { gdlg.close(); }); });
      gdlg.addEventListener("click", function (e) { if (e.target === gdlg) gdlg.close(); });
    }
    $$("[data-support-dialog], [data-mm-support-dialog]").forEach(enhanceSupport);
    if (actions && !$(".header-support", actions)) {
      var hs = document.createElement("button");
      hs.type = "button"; hs.className = "icon-btn header-support"; hs.setAttribute("aria-label", mmS("customer_support", "Customer support"));
      hs.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' + HEADSET + "</svg>";
      hs.addEventListener("click", function () {
        var d = $("[data-support-dialog]") || $("[data-mm-support-dialog]");
        if (d && d.showModal) { enhanceSupport(d); d.showModal(); }
      });
      var anchor = $(".header-currency", actions) || actions.firstChild;
      actions.insertBefore(hs, anchor);
    }
    var nav = $("#site-nav");
    // R18: the support block is no longer placed in the mobile drawer (support = header icon popup)
    extras.remove();
    $$("[data-currency-select]").forEach(function (sel) { sel.addEventListener("change", function () { sel.form.submit(); }); });

    /* R18: mobile (<750px) header = [menu][search] | logo | [support][account][Bag]; currency moves into the drawer */
    var inner = $(".site-header .header-inner");
    var toggle = $(".site-header [data-menu-toggle]");
    var searchBtn = actions && $("[data-search-open]", actions);
    var account = actions && $(".account", actions);
    if (inner && toggle && nav && actions) {
      var mqm = window.matchMedia("(max-width: 749px)");
      var left = document.createElement("div"); left.className = "mm-head-left";
      var label = $(".mm-nav-label", nav);
      if (!label) { label = document.createElement("p"); label.className = "mm-nav-label"; label.textContent = mmS("nav_shop", "Shop"); nav.insertBefore(label, nav.firstChild); }
      var allLink = $$("a", nav).filter(function (a) { return /\/collections\/all\/?$/.test(a.getAttribute("href") || ""); })[0];
      if (allLink) allLink.classList.add("mm-nav-all");
      var curRow = document.createElement("div"); curRow.className = "mm-nav-currency";
      var curLabel = document.createElement("span"); curLabel.textContent = mmS("currency", "Currency"); curRow.appendChild(curLabel);
      var layout = function () {
        var cform = $(".header-currency");
        var hsb = $(".header-support", actions);
        if (mqm.matches) {
          if (!left.parentNode) inner.insertBefore(left, inner.firstChild);
          left.appendChild(toggle);
          if (searchBtn) left.appendChild(searchBtn);
          if (hsb && account) actions.insertBefore(hsb, account);
          if (cform) { curRow.appendChild(cform); nav.appendChild(curRow); }
          if (allLink) allLink.textContent = mmS("shop_all", "Shop all");
        } else {
          inner.insertBefore(toggle, nav);
          if (left.parentNode) left.remove();
          if (searchBtn && account) actions.insertBefore(searchBtn, account);
          if (cform && account) { actions.insertBefore(cform, searchBtn || account); }
          if (hsb && cform) actions.insertBefore(hsb, cform);
          if (curRow.parentNode) curRow.remove();
          if (allLink) allLink.textContent = mmS("nav_all", "All");
          nav.classList.remove("is-open"); toggle.setAttribute("aria-expanded", "false");
        }
      };
      layout();
      if (mqm.addEventListener) mqm.addEventListener("change", layout);
      // keep the toggle's accessible name in sync with its state
      toggle.addEventListener("click", function () {
        setTimeout(function () { toggle.setAttribute("aria-label", nav.classList.contains("is-open") ? mmS("close_navigation", "Close navigation") : mmS("open_navigation", "Open navigation")); }, 0);
      });
    }
  }

  /* ---------- PDP ---------- */
  var pdp = $(".pdp-wrap") || $("[data-pdp-video-modal]");
  if (pdp) {
    // 1: remove scroll-to-top pill
    $$("[data-scroll-top], .pdp-top").forEach(function (n) { n.remove(); });
    // 17: Secure Payment line
    $$(".pdp-safe").forEach(function (n) {
      n.classList.add("pdp-secure");
      n.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path fill="currentColor" d="M7 1.2 3.2 2.6v3.3c0 2.5 1.6 4.8 3.8 5.7 2.2-.9 3.8-3.2 3.8-5.7V2.6L7 1.2Zm0 6.3h2.6c-.3 1.6-1.2 3-2.6 3.7V7.5H4.4V3.5L7 2.6v4.9Z"/></svg> ' + mmS("secure_payment", "Secure Payment");
    });
    // 13: one heading for both video-review rows
    $$(".pdp-section-title").forEach(function (h) { if (h.hasAttribute("data-mm-loved") || /Loved by 1,000\+ Ladies Worldwide/i.test(h.textContent)) h.textContent = mmS("loved_customers", "Loved by 1,000+ Customers"); });
    // 10: Best Sellers "Shop all" -> arrow link in the heading row
    $$(".pdp-band").forEach(function (band) {
      var title = $(".pdp-section-title", band);
      if (!title) return;
      var row = title.closest(".pdp-row");
      var t = title.getAttribute("data-mm-band") || title.textContent.trim().toLowerCase();
      if (t === "best sellers") {
        var btn = $(".pdp-shop-all a", band);
        var old = $(".pdp-row > .pdp-link", band);
        var href = (btn && btn.getAttribute("href")) || (old && old.getAttribute("href")) || mmP("/collections/all");
        if (row && !$(".pdp-viewall", row)) row.appendChild(arrowLink("pdp-viewall", href, btn ? mmS("shop_all", "Shop all") : mmS("view_all", "View all")));
        if (btn) btn.closest(".pdp-shop-all").remove();
        if (old) old.remove();
      } else if (t === "made to match") {
        band.classList.add("pdp-match");
        var link = $(".pdp-row > .pdp-link", band);
        if (row && link) { row.replaceChild(arrowLink("pdp-viewall", link.getAttribute("href") || mmP("/collections/underwear"), mmS("shop_underwear", "Shop underwear")), link); }
        var list = readJSON("mm-match-data");
        var cards = $(".pdp-cards", band);
        if (list && list.length && cards) {
          var here = location.pathname.replace(/\/$/, "");
          var items = list.filter(function (i) { return String(i.url).split("?")[0].replace(/\/$/, "") !== here; });
          if (!items.length) items = list;
          items = items.slice(0, 8);
          cards.innerHTML = "";
          items.forEach(function (i) { cards.appendChild(card(i)); });
        }
      }
    });
    // 20: count product-page views for "More to love" in the bag
    try {
      var key = "mellomy-views";
      var views = JSON.parse(localStorage.getItem(key) || "{}");
      var path = location.pathname.replace(/\/$/, "");
      views[path] = { n: ((views[path] && views[path].n) || 0) + 1, t: Date.now() };
      localStorage.setItem(key, JSON.stringify(views));
    } catch (e) {}
    // 12: video review popup opens with sound at 25%
    var pv = $("[data-vmodal-video]"), ps = $("[data-vmodal-sound]");
    if (pv) {
      pv.volume = VOL;
      $$("[data-pdp-review]").forEach(function (b) {
        b.addEventListener("click", function () { setTimeout(function () {
          pv.volume = VOL; pv.muted = false;
          if (ps) ps.classList.add("is-on");
          var p = pv.play();
          if (p && p.catch) p.catch(function () { pv.muted = true; if (ps) ps.classList.remove("is-on"); pv.play().catch(function () {}); });
        }, 0); });
      });
      pv.addEventListener("volumechange", function () { if (!pv.muted && pv.volume > VOL) pv.volume = VOL; });
    }
  }

  /* ---------- Home "In her own words" ---------- */
  var hv = $("[data-home-video]");
  if (hv) {
    hv.volume = VOL; // previews stay muted autoplay; the popup plays with sound at 25%
    hv.addEventListener("volumechange", function () { if (!hv.muted && hv.volume > VOL) hv.volume = VOL; });
    hv.addEventListener("play", function () { if (!hv.muted) hv.volume = VOL; });
    var close = $(".women-video-stories .pdp-vmodal__close");
    if (close) close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round"/></svg>';
  }

  /* ---------- Collection: "+N" = thumbnails hidden at this breakpoint ---------- */
  var grid = $("[data-plp-grid]");
  if (grid) {
    // R17: show as many swatches as fit (cap: mobile 5, tablet 6, desktop 7), then "+N" right after them
    var mq = window.matchMedia("(max-width: 749px)");
    var mqd = window.matchMedia("(min-width: 990px)");
    var countMore = function () {
      var cap = mq.matches ? 5 : (mqd.matches ? 7 : 6);
      $$(".plp-card", grid).forEach(function (c) {
        var row = $(".plp-swatches", c);
        var sws = $$(".plp-swatch", c);
        var more = $("[data-plp-more]", c);
        if (!row || !sws.length) return;
        row.classList.add("mm-fit");
        if (row.classList.contains("is-open")) return;
        var total = sws.length;
        var sw = mq.matches ? 22 : 30, g = mq.matches ? 4 : 5, chip = mq.matches ? 26 : 36;
        var W = row.clientWidth || 0;
        var fit = cap;
        if (W > 0) {
          var allFit = Math.floor((W + g) / (sw + g));
          fit = total <= Math.min(allFit, cap) ? total : Math.floor((W - chip) / (sw + g));
        }
        var shown = Math.max(1, Math.min(fit, cap, total));
        sws.forEach(function (s, i) { s.classList.toggle("mm-off", i >= shown); });
        var rest = total - shown;
        if (more) { more.textContent = "+" + rest; more.hidden = rest <= 0; more.setAttribute("aria-label", mmF("more_colors", "{n} more colors", { n: rest })); }
      });
    };
    countMore();
    var rt = 0;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(countMore, 150); });
    if (mq.addEventListener) { mq.addEventListener("change", countMore); mqd.addEventListener("change", countMore); }
  }

  /* ---------- Bag ---------- */
  var bag = $(".bag");
  if (bag) {
    var support = $("[data-support-dialog]");
    // 16: support hint next to the "Bag" title
    var h1 = $(".bag-wrap > h1");
    if (h1 && !$(".bag-head")) {
      var head = document.createElement("div"); head.className = "bag-head";
      h1.parentNode.insertBefore(head, h1); head.appendChild(h1);
      var sb = document.createElement("button");
      sb.type = "button"; sb.className = "bag-head-support";
      sb.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 13v-1a8 8 0 0 1 16 0v1" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="3" y="13" width="4" height="6" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/><rect x="17" y="13" width="4" height="6" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>Customer support';
      sb.addEventListener("click", function () { if (support && support.showModal) support.showModal(); });
      head.appendChild(sb);
    }
    // 15: "View full details" next to Size Chart in the edit popup
    var chartBtn = $("[data-open-bag-chart]");
    if (chartBtn && !$("[data-edit-full]")) {
      var wrap = document.createElement("span"); wrap.className = "bag-size-links";
      chartBtn.parentNode.insertBefore(wrap, chartBtn); wrap.appendChild(chartBtn);
      var full = document.createElement("a");
      full.className = "bag-chart-link bag-full-link"; full.href = "#"; full.setAttribute("data-edit-full", ""); full.textContent = mmS("view_full_details", "View full details");
      wrap.appendChild(full);
      $$(".bag-line [data-edit]").forEach(function (b) {
        b.addEventListener("click", function () {
          var l = b.closest(".bag-line"); var a = l && l.querySelector("a[href]");
          if (a) full.href = a.getAttribute("href");
        }, true);
      });
    }
    // 20: More to love = most-viewed / recently viewed, topped up with homepage Best sellers
    var box = $(".bag-love .bag-cards");
    var best = readJSON("mm-bestsellers") || [];
    var loveSection = $(".bag-love");
    if (!loveSection && best.length) {
      loveSection = document.createElement("section"); loveSection.className = "bag-love";
      loveSection.innerHTML = "<h2>" + mmS("more_to_love", "More to love") + "</h2><div class=\"bag-cards\"></div>";
      $(".bag-wrap").appendChild(loveSection); box = $(".bag-cards", loveSection);
    }
    if (box) {
      var inCart = {}, inPath = {};
      $$(".bag-line").forEach(function (l) {
        inCart[String(l.dataset.product)] = 1;
        var a = l.querySelector("a[href]");
        if (a) { try { inPath[new URL(a.href, location.origin).pathname.replace(/\/$/, "")] = 1; } catch (e) {} }
      });
      var pathOf = function (u) { try { return new URL(u, location.origin).pathname.replace(/\/$/, ""); } catch (e) { return u; } };
      var recent = [], views = {};
      try { recent = JSON.parse(localStorage.getItem("mellomy-recent") || "[]"); } catch (e) {}
      try { views = JSON.parse(localStorage.getItem("mellomy-views") || "{}"); } catch (e) {}
      recent = recent.filter(function (e) { return e && e.url && e.title; }).map(function (e, i) {
        var v = views[e.url.replace(/\/$/, "")] || {};
        var curNow = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
        return { id: e.id, url: e.url, title: e.title, image: e.image, price: (e.cur || "USD") === curNow ? e.price : "", n: v.n || 1, t: v.t || 0, i: i };
      });
      recent = recent.filter(function (e) { return !(e.id && inCart[String(e.id)]) && !inPath[pathOf(e.url)]; });
      recent.sort(function (a, b) { return (b.n - a.n) || (a.i - b.i); });
      var picks = recent.slice(0, 4), used = {};
      picks.forEach(function (p) { used[p.url] = 1; });
      best.forEach(function (b) { if (picks.length < 4 && !used[b.url] && !inCart[String(b.id)] && !inPath[pathOf(b.url)]) { picks.push(b); used[b.url] = 1; } });
      if (picks.length) {
        box.innerHTML = "";
        picks.forEach(function (p) {
          var a = document.createElement("a"); a.href = p.url;
          var span = document.createElement("span");
          if (p.image) { var img = document.createElement("img"); sharpImg(img, p.image, "(min-width: 990px) 25vw, 50vw"); img.alt = p.title; img.loading = "lazy"; span.appendChild(img); }
          var t = document.createElement("p"); t.textContent = p.title;
          var s = document.createElement("strong"); s.textContent = p.price || "";
          a.appendChild(span); a.appendChild(t); a.appendChild(s);
          box.appendChild(a);
        });
      }
    }
  }
})();
(function () {
  var L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5 8 12l7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function arrows(el) {
    if (!el || el.dataset.mmArrows) return;
    el.dataset.mmArrows = "1";
    var wrap = document.createElement("div"); wrap.className = "mm-scroll-wrap";
    el.parentNode.insertBefore(wrap, el); wrap.appendChild(el);
    function mk(dir) {
      var b = document.createElement("button"); b.type = "button";
      b.className = "mm-arrow mm-arrow--" + (dir < 0 ? "prev" : "next");
      b.setAttribute("aria-label", dir < 0 ? mmS("scroll_back", "Scroll back") : mmS("scroll_forward", "Scroll forward"));
      b.innerHTML = dir < 0 ? L : R;
      b.addEventListener("click", function () { el.scrollBy({ left: dir * Math.max(el.clientWidth * 0.8, 160), behavior: "smooth" }); });
      wrap.appendChild(b); return b;
    }
    var p = mk(-1), n = mk(1);
    function upd() {
      var over = el.scrollWidth - el.clientWidth > 4;
      p.hidden = !over || el.scrollLeft <= 4;
      n.hidden = !over || el.scrollLeft >= el.scrollWidth - el.clientWidth - 4;
    }
    el.addEventListener("scroll", upd, { passive: true });
    window.addEventListener("resize", upd);
    setTimeout(upd, 300); setTimeout(upd, 1500); upd();
  }
  function init() {
    document.querySelectorAll(".women-video-stories__grid, .pdp-match .pdp-cards, .pdp-cards").forEach(arrows);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(init, 50); });
  else setTimeout(init, 50);
})();
